import {useEffect, useState} from 'react';
import {getFancyTextEffectsHashmap} from '@Libraries/fancy-text-library';
import {setFancyTextEffectHashamp} from '@Panels/add-fancytext-panel/add-fancy-text-container.reducer';
import {openErrorModal} from '@Modals/error-modal';
import {useAppDispatch, useAppSelector} from '@/hooks';

export function usePopulateFancyTextData(): boolean {
  const fancyTextHashmap = useAppSelector((state) => {
    return state.fancyText.data.fancyTextEffectHashmap;
  });
  const [hasPopulated, setHasPopulated] = useState(false);
  const dispatch = useAppDispatch();

  useEffect((): void => {
    if (!fancyTextHashmap || Object.keys(fancyTextHashmap).length === 0) {
      getFancyTextEffectsHashmap()
        .then((res) => {
          setHasPopulated(true);
          dispatch(setFancyTextEffectHashamp(res));
        })
        .catch(() => {
          openErrorModal({
            message: window.i18next.t('pmwjs_error_message'),
          });
        });
    } else {
      setHasPopulated(true);
    }
  }, []);

  return hasPopulated;
}
